import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { BTN_DARK_THEME, Button, CONTAINED_VARIANT, GHOST_VARIANT, NO_ICON, SIZE_44, } from '@yme/atoms/button';
import { usePrevious, useWindowSize } from '@yme/common/hooks';
import { useProfileMenu } from '@yme/components/Header/SignInMenuItem/useProfileMenu';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { getSanitizeHtml, reloadPage } from '@yme/utils/common';
import { getAuthorizedStatus } from '../Header/ProfileMenu/redux/selectors';
import { BackgroundImageStyled, ContentWrapperStyled, DescriptionStyled, GridWrapperStyled, ImageContainerStyled, SubTitleStyled, TitleStyled, } from './styled';
export function Error403({ title, subtitle, description, backgroundImage, }) {
    const { t } = useTranslation();
    const location = useLocation();
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const { signInHandler, signUpHandler } = useProfileMenu();
    const isAuthorized = useSelector(getAuthorizedStatus);
    const prevIsAuthorized = usePrevious(isAuthorized);
    const isEmptyData = [title, subtitle, description, backgroundImage].some((value) => !value);
    useEffect(() => {
        const hasAuthorizationChanged = prevIsAuthorized !== isAuthorized;
        const isNot403Page = !(location.pathname.split('/').filter(Boolean).at(-1) === '403');
        if (hasAuthorizationChanged && isNot403Page && isAuthorized) {
            reloadPage();
        }
    }, [isAuthorized, location.pathname, prevIsAuthorized]);
    if (isEmptyData) {
        return null;
    }
    const sanitizedDescription = getSanitizeHtml(description);
    return (React.createElement(ImageContainerStyled, { flexDirection: "column" },
        React.createElement(BackgroundImageStyled, { backgroundImage: backgroundImage, flexDirection: "column" },
            React.createElement(GridWrapperStyled, { containerProps: {
                    width: '100%',
                    height: '100%',
                }, rowProps: {
                    height: '100%',
                } },
                React.createElement(ContentWrapperStyled, null,
                    React.createElement(SubTitleStyled, { color: colorCoreWhite1000 }, subtitle),
                    React.createElement(TitleStyled, { color: colorCoreWhite1000 }, title),
                    React.createElement(DescriptionStyled, { dangerouslySetInnerHTML: {
                            __html: sanitizedDescription,
                        } }),
                    React.createElement(FlexWrapper, { gap: isInfiniteDesktopView ? '24px' : '16px', flexDirection: isMobileView ? 'column' : 'row', mtDesktop: "24px", mtMobile: "16px" },
                        React.createElement(Button, { size: SIZE_44, hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, colorSchema: BTN_DARK_THEME, label: t('error403_registerMyYamahaAccount_button'), onClick: signUpHandler, width: "auto" }),
                        React.createElement(Button, { size: SIZE_44, hasIconButton: NO_ICON, buttonVariant: GHOST_VARIANT, colorSchema: BTN_DARK_THEME, label: t('error403_loginWithExistingAccount_button'), onClick: signInHandler, width: "auto" })))))));
}
Error403.displayName = 'Error403_AEMComponent';
